module.exports = __webpack_public_path__ + "static/media/dollar-bag-hand.40697dee.svg";